<template>
  <div>
    <div class="loading-area">
      <v-btn
        class="loading-button"
        fab
        :loading="loading"
        v-if="loading"
        elevation= "2"
      ></v-btn>
    </div>
    <v-card
      class="mx-auto"
      max-width="1440"
      outlined
      elevation="0"
      v-if="!loading"
    >
      <card-header :diaryType="'student'" @studentsLoaded="reloadStudents" />
      <baby-diary class="height-area" :classId="classId" :students="diaryData" @updatedStudent="catchChanges"/>
    </v-card>
  </div>
</template>

<script>
import { DIARY_DATA, UPDATE_STUDENT_DIARY } from '@/store/actions/user'
import BabyDiary from '@/components/diaryType/BabyDiary/index.vue'
import CardHeader from '@/components/Elements/CardHeader.vue'
export default {
  components: { BabyDiary, CardHeader },
  created () {
    this.classId = this.$route.params.classId.toString() || ''
    this.loading = true
    this.$store.dispatch(DIARY_DATA, this.classId).then((data) => {
      this.loading = false
      this.students = data.student
    }, (error) => { // Failure
      console.log('Error en Formulario Agenda')
      console.log({error})
    })
  },
  data: () => ({
    classId: '',
    students: undefined,
    selectedItem: 1,
    selectedClass: undefined,
    loading: false
  }),
  computed: {
    diaryData: function () {
      return this.students
    }
  },
  methods: {
    reloadStudents: function (students) {
      this.students = students.student
    },
    catchChanges: function (newVersion) {
      // console.log({newVersion})
      this.$store.dispatch(UPDATE_STUDENT_DIARY, {classId: this.classId, studentData: newVersion}).then((data) => {
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/agendaForm.vue